<template>
    <div>
        <div class="w-100 h-100">
            <Nav :rolname="rolname" />
        </div>
        <div class="content m-auto">
            <Home v-if="page == 'home'" @mtdChangePage="mtdChangePage" @mtdBackCampus="mtdBackCampus" />
            <OC v-if="page == 'oc'" @returnHome="returnHome" @mtdChangePage="mtdChangePage"
                @mtdChangeFilter="mtdChangeFilter" />
            <Mantenimiento v-if="page == 'mantenimiento'" @returnHome="returnHome" />
            <OS v-if="page == 'servicios'" @returnHome="returnHome" />
            <Factura v-if="page == 'factura'" @returnHome="returnHome" />
            <Compra v-if="page == 'compra'" @returnHome="returnHome" />
            <Cxp v-if="page == 'cxp'" @returnHome="returnHome" />
            <Inventario v-if="page == 'inventario'" @returnHome="returnHome" />
            <StockMin v-if="page == 'stockmin'" @returnHome="returnHome" />
            <Side v-if="page == 'sire'" @returnHome="returnHome" />
            <Ubicacion v-if="page == 'ubicacion'" @returnHome="returnHome" />
            <NewReport v-if="page == 'new_report'" @returnHome="returnHome" />
            <Requerimiento v-if="page == 'requerimiento'" @returnHome="returnHome" />
            <HisMovimiento v-if="page == 'hisMovimiento'" @returnHome="returnHome" />
            <Movimiento v-if="page == 'movimiento'" @returnHome="returnHome" @mtdChangePage="mtdChangePage" />
            <Kardex v-if="page == 'kardex'" @returnHome="returnHome" />
            <KardexInt v-if="page == 'kardexInterno'" @returnHome="returnHome" />
            <Verificacion v-if="page == 'verificacion'" @returnHome="returnHome" @mtdChangePage="mtdChangePage" />
            <NotaIngreso v-if="page == 'notaIngreso'" @returnHome="returnHome" />
            <reportVerificacion v-if="page == 'repVerificacion'" @returnHome="returnHome"
                @mtdChangePage="mtdChangePage" />
            <Stock v-if="page == 'stock'" @returnHome="returnHome" />
            <Permisos v-if="page == 'permision'" @returnHome="returnHome" />
            <LogisticaVue v-if="page == 'note_income'" @returnHome="returnHome" />
            <PurchaseNew v-if="page == 'new_purchase'" @returnHome="returnHome" />
            <StockStatistics v-if="page == 'stock_stats'" @returnHome="returnHome" />
        </div>
        <div class="footer">
            <Footer @mtdChangePage="mtdChangePage" :pageView="page" />
        </div>
    </div>
</template>

<script>
import {
    mapActions
} from 'vuex'
import Nav from '../../components/Asistencial/Nav.vue'
import Home from "../../components/Logistica/Home.vue";
import Footer from "../../components/Logistica/Footer.vue";
import OC from "../../components/Logistica/pages/Ordendecompra.vue";
import Mantenimiento from "../../components/Logistica/pages/Mantenimiento.vue";
import OS from "../../components/Logistica/pages/Ordendeservicios.vue";
import Factura from "../../components/Logistica/pages/ReporteFactura.vue";
import Cxp from '@/components/Logistica/pages/Cxp.vue';
import Compra from '@/components/Logistica/pages/Compra.vue';
import HisMovimiento from "../../components/Logistica/pages/HisMovimiento.vue";
import Movimiento from '@/components/Logistica/pages/Movimiento.vue';
import Requerimiento from "@/components/Logistica/pages/Requerimiento.vue";
import Inventario from "../../components/Logistica/pages/Inventory.vue";
import StockMin from "@/components/Logistica/pages/Stockminimo.vue";
import Side from "../../components/Logistica/pages/Side.vue";
import Ubicacion from "../../components/Logistica/pages/Ubicacion/Ubicacion.vue";
import NewReport from "../../components/Logistica/pages/Reportes/MovementReport.vue";
import PurchaseNew from "../../components/Logistica/pages/PurchaseNew.vue";
/* verificacion de stocks */
import Verificacion from "../../components/Logistica/pages/VerificacionStock.vue";
import reportVerificacion from "../../components/Logistica/pages/ReportVerificacionStock.vue";
import NotaIngreso from "../../components/Logistica/pages/NotaIngreso.vue";
//Kardex
import Kardex from "../../components/Logistica/pages/Kardex.vue";
import KardexInt from "../../components/Logistica/pages/KarInterno.vue";
import Stock from "../../components/Logistica/pages/Stock.vue"
import Permisos from '@/components/Logistica/pages/Permisos.vue';
import LogisticaVue from "@/components/Gerencia/pages/LogisticaView.vue";
import StockStatistics from "../../components/Logistica/pages/StockStatistics.vue";
/*** otros permisos */


export default {
    name: "LogisticaView",
    components: {
        Nav,
        Home,
        OS,
        OC,
        Mantenimiento,
        Inventario,
        Factura,
        Cxp,
        Compra,
        Requerimiento,
        HisMovimiento,
        Movimiento,
        Footer,
        StockMin,
        Side,
        Ubicacion,
        Kardex,
        KardexInt,
        Verificacion,
        reportVerificacion,
        NotaIngreso,
        Stock,
        Permisos,
        LogisticaVue,
        NewReport,
        PurchaseNew,
        StockStatistics,
    },
    data() {
        return {
            prefix: 'logistica',
            page: 'home',
            filter: {},
        }
    },
    props: {
        rolname: String,
    },
    created() {
        this.rol_name = this.rolname;
    },
    methods: {
        ...mapActions(['get', 'post']),
        mtdChangePage: function (page) {
            this.page = page;
        },
        returnHome: function () {
            this.page = "home";
        },
        mtdBackCampus: function () {
            this.$emit("mtdBackCampus");
        },
        mtdChangeFilter: function (data) {
            this.filter = data;
        },
    }

}
</script>
